module.exports = __webpack_public_path__ + "img/MW.bc1c7c4c.png";